// extracted by mini-css-extract-plugin
export default {"container":"w3i6WpDA2QB2UdM5DO1n"};